import styles from "./Row.module.sass";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../components/Checkbox";
import { getPartnerById } from "../../../../services/partner.service";
import { formatDateForInput } from "../../../../services/date.service";

const Row = ({ item, selected, onSelect, onStatusChange }) => {
    const navigate = useNavigate();

    // Fonction pour obtenir l'URL du logo
    const getLogoUrl = () => {
        if (item.logo) {
            // Si c'est déjà une URL complète
            if (item.logo.startsWith('http')) {
                return item.logo;
            }
            // Sinon, construire l'URL PocketBase
            return `${process.env.REACT_APP_POCKETBASE_URL}/api/files/partners/${item.id}/${item.logo}`;
        }
        // Logo par défaut si pas de logo
        return '/images/content/company_logo.png';
    };

    const handleRowClick = async () => {
        try {
            const partnerData = await getPartnerById(item.id);
            navigate(`/partners/${item.id}`, { state: { partner: partnerData } });
        } catch (error) {
            console.error('Erreur lors de la récupération des données du partenaire:', error);
            navigate(`/partners/${item.id}`, { state: { partner: item } });
        }
    };

    const handleStatusToggle = (e) => {
        e.stopPropagation();
        onStatusChange?.(item.id, !item.is_active);
    };

    return (
        <>
            <div className={styles.row} style={{ cursor: 'pointer' }}>
                <div className={styles.col} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        className={styles.checkbox}
                        checked={selected}
                        onChange={(e) => {
                            e.stopPropagation();
                            onSelect && onSelect(item.id);
                        }}
                    />
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.item}>
                        <div className={styles.avatar}>
                            <img src={getLogoUrl()} alt="Logo partenaire" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.user}>{item.name}</div>
                            <div className={styles.login}>{item.subscription_plan || 'Plan non défini'}</div>
                            <div className={styles.email}>{item.admin_contact_name}</div>
                        </div>
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.email}>{item.subscription_plan}</div>
                </div>
                
                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.email}>{item.email}</div>
                    <div className={styles.phone}>{item.phone}</div>
                </div>
                
                <div className={styles.col} onClick={(e) => e.stopPropagation()}>
                    <div 
                        className={cn('status-type', item.is_active ? 'status-green-dark' : 'status-red-dark')}
                        onClick={handleStatusToggle}
                        style={{ cursor: 'pointer' }}
                    >
                        {item.is_active ? 'Actif' : 'Inactif'}
                    </div>
                    {item.demo_account && (
                        <div className={cn('status-type', 'status-yellow', styles.demo)}>
                            Demo
                        </div>
                    )}
                </div>

            </div>
        </>
    );
};

export default Row;
